export default "/static/dashboard/build/app/img/v2/dc4ee026fd75d0600563a2dc2dfc2c47.png";